export default {
	auth: (
		<svg
			width="204"
			height="205"
			viewBox="0 0 204 205"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="101.823"
				y="0.698486"
				width="144"
				height="144"
				transform="rotate(45 101.823 0.698486)"
				fill="#E9FB1E"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M120.377 38.6985H30V106.481H69.1492L66.4677 116.824C65.9277 118.907 64.2514 120.502 62.1444 120.938L49.205 123.615V128.698H100.607V123.615L87.2691 120.947C85.0759 120.509 83.3481 118.817 82.8629 116.634L80.6067 106.481H120.377V38.6985Z"
				fill="white"
			/>
			<mask
				id="mask0_3502_2"
				style={{ maskType: 'alpha' }}
				maskUnits="userSpaceOnUse"
				x="30"
				y="38"
				width="91"
				height="91"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M120.377 38.6985H30V106.481H69.1492L66.4677 116.824C65.9277 118.907 64.2514 120.502 62.1444 120.938L49.205 123.615V128.698H100.607V123.615L87.2691 120.947C85.0759 120.509 83.3481 118.817 82.8629 116.634L80.6067 106.481H120.377V38.6985Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_3502_2)"></g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32 40.6985H118.377V104.481H32V40.6985ZM30 38.6985H32H118.377H120.377V40.6985V104.481V106.481H118.377H80.6681L82.8629 116.358C83.3481 118.541 85.076 120.232 87.2692 120.671L100.607 123.339V126.422V128.422H98.6068H51.2051H49.2051V126.422V123.339L62.1444 120.662C64.2514 120.226 65.9278 118.631 66.4678 116.548L69.0777 106.481H32H30V104.481V40.6985V38.6985ZM68.4038 117.05L71.0874 106.698H78.6677L80.9106 116.791C81.5676 119.748 83.9072 122.038 86.877 122.632L98.6068 124.978V126.422H51.2051V124.967L62.5497 122.62C65.4027 122.03 67.6726 119.87 68.4038 117.05ZM61.6317 70.5186H72.9288V72.0249H61.6317V70.5186ZM86.4852 75.6022H61.6317V77.1085H86.4852V75.6022ZM39.2264 46.4181C39.2264 47.25 38.552 47.9244 37.7201 47.9244C36.8882 47.9244 36.2139 47.25 36.2139 46.4181C36.2139 45.5862 36.8882 44.9119 37.7201 44.9119C38.552 44.9119 39.2264 45.5862 39.2264 46.4181ZM44.4975 47.9244C45.3294 47.9244 46.0038 47.25 46.0038 46.4181C46.0038 45.5862 45.3294 44.9119 44.4975 44.9119C43.6656 44.9119 42.9912 45.5862 42.9912 46.4181C42.9912 47.25 43.6656 47.9244 44.4975 47.9244ZM52.7821 46.4181C52.7821 47.25 52.1077 47.9244 51.2758 47.9244C50.4439 47.9244 49.7695 47.25 49.7695 46.4181C49.7695 45.5862 50.4439 44.9119 51.2758 44.9119C52.1077 44.9119 52.7821 45.5862 52.7821 46.4181ZM73.1835 58.2993C76.0561 56.6408 79.5953 56.6408 82.468 58.2993L88.8588 61.989C91.7314 63.6476 93.501 66.7126 93.501 70.0297V77.4091C93.501 80.7262 91.7314 83.7913 88.8588 85.4498L82.468 89.1395C79.5953 90.798 76.0561 90.798 73.1835 89.1395L66.7926 85.4498C64.7276 84.2575 63.2325 82.3383 62.5551 80.1212H64.674C65.2721 81.6118 66.3568 82.8887 67.7926 83.7177L74.1835 87.4075C76.4373 88.7087 79.2141 88.7087 81.468 87.4075L87.8588 83.7177C90.1126 82.4165 91.501 80.0117 91.501 77.4091V70.0297C91.501 67.4272 90.1126 65.0223 87.8588 63.7211L81.468 60.0314C79.2141 58.7301 76.4373 58.7301 74.1835 60.0314L67.7926 63.7211C66.3567 64.5502 65.272 65.8272 64.6739 67.3179H62.555C63.2324 65.1006 64.7275 63.1814 66.7926 61.989L73.1835 58.2993Z"
				fill="#0C0722"
			/>
			<circle cx="142.727" cy="151.426" r="22.7273" fill="white" />
			<circle cx="146.859" cy="155.558" r="22.7273" fill="#FB1E9B" />
			<mask
				id="mask1_3502_2"
				style={{ maskType: 'alpha' }}
				maskUnits="userSpaceOnUse"
				x="123"
				y="132"
				width="46"
				height="46"
			>
				<circle cx="146.033" cy="154.731" r="22.7273" fill="#66C6F1" />
			</mask>
			<g mask="url(#mask1_3502_2)">
				<circle
					cx="142.727"
					cy="151.426"
					r="21.7273"
					stroke="#0C0722"
					strokeWidth="2"
				/>
			</g>
			<path
				d="M139 60.6985L149.562 70.6985L160.125 60.6985L170.687 70.6985L181.25 60.6985L191.812 70.6985L202.374 60.6985"
				stroke="#0C0722"
				strokeWidth="2"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
		</svg>
	),
	сonfirm: (
		<svg
			width="204"
			height="205"
			viewBox="0 0 204 205"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="101.823"
				y="0.698486"
				width="144"
				height="144"
				rx="72"
				transform="rotate(45 101.823 0.698486)"
				fill="#FB1E9B"
			/>
			<circle cx="77" cy="84.6985" r="35" fill="white" />
			<mask id="path-3-inside-1_3502_3" fill="white">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M110.416 84.6985C110.416 102.913 95.5593 117.698 77.2079 117.698C58.8565 117.698 44 102.913 44 84.6985C44 66.4842 58.8565 51.6985 77.2079 51.6985C86.8653 51.6985 95.5548 55.7932 101.621 62.3275L75.449 92.4525L62.3845 76.5326L60.8384 77.8013L74.6542 94.6367L75.4054 95.5522L76.1821 94.6582L102.949 63.8482C107.617 69.5334 110.416 76.793 110.416 84.6985ZM104.278 62.318C109.359 68.3849 112.416 76.1869 112.416 84.6985C112.416 104.028 96.6527 119.698 77.2079 119.698C57.7631 119.698 42 104.028 42 84.6985C42 65.3685 57.7631 49.6985 77.2079 49.6985C87.3629 49.6985 96.5137 53.9723 102.94 60.8094L108.543 54.3592L110.053 55.6709L104.278 62.318Z"
				/>
			</mask>
			<path
				d="M101.621 62.3275L103.13 63.6391L104.308 62.2832L103.086 60.9668L101.621 62.3275ZM75.449 92.4525L73.9029 93.7213L75.4054 95.5522L76.9588 93.7642L75.449 92.4525ZM62.3845 76.5326L63.9305 75.2638L62.6618 73.7178L61.1157 74.9865L62.3845 76.5326ZM60.8384 77.8013L59.5697 76.2552L58.0236 77.524L59.2924 79.07L60.8384 77.8013ZM74.6542 94.6367L73.1081 95.9055V95.9055L74.6542 94.6367ZM75.4054 95.5522L73.8594 96.821L75.3619 98.6519L76.9153 96.8639L75.4054 95.5522ZM76.1821 94.6582L74.6723 93.3465L74.6723 93.3465L76.1821 94.6582ZM102.949 63.8482L104.494 62.579L102.992 60.7491L101.439 62.5366L102.949 63.8482ZM104.278 62.318L102.768 61.0063L101.65 62.2942L102.745 63.6021L104.278 62.318ZM102.94 60.8094L101.482 62.1791L102.998 63.7918L104.449 62.121L102.94 60.8094ZM108.543 54.3592L109.855 52.8494L108.345 51.5377L107.033 53.0475L108.543 54.3592ZM110.053 55.6709L111.563 56.9825L112.875 55.4727L111.365 54.1611L110.053 55.6709ZM77.2079 119.698C96.6529 119.698 112.416 104.028 112.416 84.6985H108.416C108.416 101.797 94.4657 115.698 77.2079 115.698V119.698ZM42 84.6985C42 104.028 57.7629 119.698 77.2079 119.698V115.698C59.9501 115.698 46 101.797 46 84.6985H42ZM77.2079 49.6985C57.7629 49.6985 42 65.3687 42 84.6985H46C46 67.5998 59.9501 53.6985 77.2079 53.6985V49.6985ZM103.086 60.9668C96.6566 54.0404 87.4424 49.6985 77.2079 49.6985V53.6985C86.2882 53.6985 94.453 57.546 100.155 63.6882L103.086 60.9668ZM76.9588 93.7642L103.13 63.6391L100.111 61.0158L73.9392 91.1409L76.9588 93.7642ZM60.8384 77.8013L73.9029 93.7213L76.995 91.1838L63.9305 75.2638L60.8384 77.8013ZM62.1072 79.3474L63.6532 78.0786L61.1157 74.9865L59.5697 76.2552L62.1072 79.3474ZM76.2002 93.368L62.3845 76.5326L59.2924 79.07L73.1081 95.9055L76.2002 93.368ZM76.9515 94.2835L76.2002 93.368L73.1081 95.9055L73.8594 96.821L76.9515 94.2835ZM74.6723 93.3465L73.8956 94.2405L76.9153 96.8639L77.6919 95.9699L74.6723 93.3465ZM101.439 62.5366L74.6723 93.3465L77.6919 95.9699L104.459 65.1599L101.439 62.5366ZM112.416 84.6985C112.416 76.3122 109.445 68.6078 104.494 62.579L101.403 65.1175C105.789 70.459 108.416 77.2739 108.416 84.6985H112.416ZM114.416 84.6985C114.416 75.6989 111.182 67.4464 105.812 61.0338L102.745 63.6021C107.537 69.3234 110.416 76.6749 110.416 84.6985H114.416ZM77.2079 121.698C97.7461 121.698 114.416 105.144 114.416 84.6985H110.416C110.416 102.913 95.5593 117.698 77.2079 117.698V121.698ZM40 84.6985C40 105.144 56.6697 121.698 77.2079 121.698V117.698C58.8565 117.698 44 102.913 44 84.6985H40ZM77.2079 47.6985C56.6697 47.6985 40 64.2528 40 84.6985H44C44 66.4842 58.8565 51.6985 77.2079 51.6985V47.6985ZM104.397 59.4397C97.6075 52.2158 87.9355 47.6985 77.2079 47.6985V51.6985C86.7902 51.6985 95.4199 55.7289 101.482 62.1791L104.397 59.4397ZM104.449 62.121L110.053 55.6709L107.033 53.0475L101.43 59.4977L104.449 62.121ZM107.232 55.869L108.741 57.1807L111.365 54.1611L109.855 52.8494L107.232 55.869ZM108.543 54.3592L102.768 61.0063L105.788 63.6296L111.563 56.9825L108.543 54.3592Z"
				fill="#0C0722"
				mask="url(#path-3-inside-1_3502_3)"
			/>
			<path d="M125.152 145.872V156.177" stroke="#0C0722" strokeWidth="2" />
			<path d="M130.305 151.025H120" stroke="#0C0722" strokeWidth="2" />
			<path d="M125.152 163.046V173.351" stroke="#0C0722" strokeWidth="2" />
			<path d="M130.305 168.198H120" stroke="#0C0722" strokeWidth="2" />
			<path d="M125.152 128.698V139.003" stroke="#0C0722" strokeWidth="2" />
			<path d="M130.305 133.851H120" stroke="#0C0722" strokeWidth="2" />
			<path d="M159.5 145.872V156.177" stroke="#0C0722" strokeWidth="2" />
			<path d="M164.652 151.025H154.348" stroke="#0C0722" strokeWidth="2" />
			<path d="M159.5 163.046V173.351" stroke="#0C0722" strokeWidth="2" />
			<path d="M164.652 168.198H154.348" stroke="#0C0722" strokeWidth="2" />
			<path d="M159.5 128.698V139.003" stroke="#0C0722" strokeWidth="2" />
			<path d="M164.652 133.851H154.348" stroke="#0C0722" strokeWidth="2" />
			<path d="M142.326 145.872V156.177" stroke="#0C0722" strokeWidth="2" />
			<path d="M147.479 151.025H137.174" stroke="#0C0722" strokeWidth="2" />
			<path d="M142.326 163.046V173.351" stroke="#0C0722" strokeWidth="2" />
			<path d="M147.479 168.198H137.174" stroke="#0C0722" strokeWidth="2" />
			<path d="M142.326 128.698V139.003" stroke="#0C0722" strokeWidth="2" />
			<path d="M147.479 133.851H137.174" stroke="#0C0722" strokeWidth="2" />
			<path
				d="M126.546 66.0346L162.308 30.2724L175.398 79.1245L126.546 66.0346Z"
				fill="white"
			/>
			<path
				d="M130.883 71.2514L166.645 35.4892L179.735 84.3413L130.883 71.2514Z"
				fill="#01FFFF"
			/>
			<path
				d="M173.984 77.7103L128.478 65.517L161.79 32.2043L173.984 77.7103Z"
				stroke="#0C0722"
				strokeWidth="2"
			/>
		</svg>
	),
	app: (
		<svg
			width="156"
			height="150"
			viewBox="0 0 156 150"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="0.823242" y="0.521729" width="144" height="144" fill="#1EFB9E" />
			<path
				d="M31 19.6982C31 13.6231 35.9249 8.69824 42 8.69824H68.6C74.6751 8.69824 79.6 13.6231 79.6 19.6982V87.6982C79.6 93.7734 74.6751 98.6982 68.6 98.6982H42C35.9249 98.6982 31 93.7734 31 87.6982V19.6982Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M68.6 10.6982H66.9996V13.3268C66.9996 16.7352 64.9554 19.4982 62.4338 19.4982H48.1655C45.6438 19.4982 43.5996 16.7352 43.5996 13.3268V10.6982H42C37.0294 10.6982 33 14.7277 33 19.6982V87.6982C33 92.6688 37.0294 96.6982 42 96.6982H68.6C73.5706 96.6982 77.6 92.6688 77.6 87.6982V19.6982C77.6 14.7277 73.5706 10.6982 68.6 10.6982ZM45.5996 10.6982H64.9996V13.3268C64.9996 14.6464 64.6012 15.7622 64.0545 16.5012C63.5075 17.2406 62.9121 17.4982 62.4338 17.4982H48.1655C47.6871 17.4982 47.0918 17.2406 46.5447 16.5012C45.998 15.7622 45.5996 14.6464 45.5996 13.3268V10.6982ZM68.6 8.69824H66.9996H64.9996H45.5996H43.5996H42C35.9249 8.69824 31 13.6231 31 19.6982V87.6982C31 93.7734 35.9249 98.6982 42 98.6982H68.6C74.6751 98.6982 79.6 93.7734 79.6 87.6982V19.6982C79.6 13.6231 74.6751 8.69824 68.6 8.69824ZM58.854 39.2645C56.6554 37.9762 53.9446 37.9762 51.746 39.2645L47.0428 42.0205C44.846 43.3078 43.5 45.6814 43.5 48.2422V53.7542C43.5 56.3151 44.846 58.6887 47.0428 59.976L51.746 62.732C53.9446 64.0203 56.6554 64.0203 58.854 62.732L63.5572 59.976C65.754 58.6887 67.1 56.3151 67.1 53.7542V48.2422C67.1 45.6814 65.754 43.3078 63.5572 42.0205L58.854 39.2645ZM52.7572 40.9901C54.3313 40.0676 56.2687 40.0676 57.8428 40.9901L62.546 43.7461C64.1219 44.6695 65.1 46.3815 65.1 48.2422V53.7542C65.1 55.6149 64.1219 57.327 62.546 58.2504L57.8428 61.0064C56.2687 61.9288 54.3313 61.9288 52.7572 61.0064L48.054 58.2504C46.4781 57.327 45.5 55.6149 45.5 53.7542V48.2422C45.5 46.3815 46.4781 44.6695 48.054 43.7461L52.7572 40.9901Z"
				fill="#0C0722"
			/>
			<path
				d="M135.762 112.274L125.916 137.925L98.4775 136.487L91.3662 109.948L114.409 94.9831L135.762 112.274Z"
				fill="white"
			/>
			<path
				d="M141.95 115.024L132.103 140.675L104.665 139.237L97.5537 112.697L120.597 97.7326L141.95 115.024Z"
				fill="#E9FB1E"
			/>
			<mask
				id="mask0_3279_13371"
				style={{ maskType: 'alpha' }}
				maskUnits="userSpaceOnUse"
				x="83"
				y="97"
				width="46"
				height="44"
			>
				<path
					d="M128.201 115.024L118.354 140.675L90.9159 139.237L83.8047 112.697L106.848 97.7326L128.201 115.024Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_3279_13371)"></g>
			<path
				d="M114.345 96.2175L134.568 112.594L125.242 136.888L99.2553 135.527L92.5202 110.39L114.345 96.2175Z"
				stroke="#0C0722"
				strokeWidth="2"
			/>
			<circle
				cx="154"
				cy="59.6982"
				r="2"
				transform="rotate(180 154 59.6982)"
				fill="#0C0722"
			/>
			<circle
				cx="144"
				cy="59.6982"
				r="2"
				transform="rotate(180 144 59.6982)"
				fill="#0C0722"
			/>
			<circle
				cx="134"
				cy="59.6982"
				r="2"
				transform="rotate(180 134 59.6982)"
				fill="#0C0722"
			/>
			<circle cx="134" cy="29.6982" r="2" fill="#0C0722" />
			<circle cx="124" cy="29.6982" r="2" fill="#0C0722" />
			<circle cx="144" cy="29.6982" r="2" fill="#0C0722" />
			<circle cx="154" cy="29.6982" r="2" fill="#0C0722" />
			<circle cx="134" cy="39.6982" r="2" fill="#0C0722" />
			<circle cx="144" cy="39.6982" r="2" fill="#0C0722" />
			<circle cx="154" cy="39.6982" r="2" fill="#0C0722" />
			<circle cx="134" cy="49.6982" r="2" fill="#0C0722" />
			<circle cx="144" cy="49.6982" r="2" fill="#0C0722" />
			<circle cx="154" cy="49.6982" r="2" fill="#0C0722" />
			<circle cx="124" cy="39.6982" r="2" fill="#0C0722" />
			<circle cx="124" cy="49.6982" r="2" fill="#0C0722" />
			<circle cx="124" cy="59.6982" r="2" fill="#0C0722" />
			<circle cx="114" cy="29.6982" r="2" fill="#0C0722" />
			<circle cx="114" cy="39.6982" r="2" fill="#0C0722" />
			<circle cx="114" cy="49.6982" r="2" fill="#0C0722" />
			<circle cx="114" cy="59.6982" r="2" fill="#0C0722" />
			<circle cx="134" cy="69.6982" r="2" fill="#0C0722" />
			<circle cx="124" cy="69.6982" r="2" fill="#0C0722" />
			<circle cx="144" cy="69.6982" r="2" fill="#0C0722" />
			<circle cx="154" cy="69.6982" r="2" fill="#0C0722" />
			<circle cx="114" cy="69.6982" r="2" fill="#0C0722" />
		</svg>
	),
	card: (
		<svg
			width="190"
			height="191"
			viewBox="0 0 190 191"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M95 0.698486L177.272 48.1985V143.198L95 190.698L12.7276 143.198V48.1985L95 0.698486Z"
				fill="#01FFFF"
			/>
			<rect x="31" y="54.6985" width="80" height="52" rx="8" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M103 56.6985H39C35.6863 56.6985 33 59.3848 33 62.6985V98.6985C33 102.012 35.6863 104.698 39 104.698H103C106.314 104.698 109 102.012 109 98.6985V62.6985C109 59.3848 106.314 56.6985 103 56.6985ZM39 54.6985C34.5817 54.6985 31 58.2802 31 62.6985V98.6985C31 103.117 34.5817 106.698 39 106.698H103C107.418 106.698 111 103.117 111 98.6985V62.6985C111 58.2802 107.418 54.6985 103 54.6985H39ZM52.0008 93.6788H39.7188V91.6788H52.0008V93.6788ZM68.4111 93.6788H56.129V91.6788H68.4111V93.6788ZM85.3341 93.6788H73.0521V91.6788H85.3341V93.6788ZM102.514 93.6788H90.2316V91.6788H102.514V93.6788ZM42 70.2185H51.2C51.7523 70.2185 52.2 70.6662 52.2 71.2185V77.1479C52.2 77.7001 51.7523 78.1479 51.2 78.1479H42C41.4477 78.1479 41 77.7002 41 77.1479V71.2185C41 70.6662 41.4477 70.2185 42 70.2185ZM39 71.2185C39 69.5616 40.3431 68.2185 42 68.2185H51.2C52.8569 68.2185 54.2 69.5616 54.2 71.2185V77.1479C54.2 78.8047 52.8569 80.1479 51.2 80.1479H42C40.3431 80.1479 39 78.8047 39 77.1479V71.2185Z"
				fill="#0C0722"
			/>
			<rect x="109" y="132.698" width="56" height="2" fill="#0C0722" />
			<rect x="109" y="142.698" width="56" height="2" fill="#0C0722" />
			<rect x="109" y="152.698" width="56" height="2" fill="#0C0722" />
			<rect x="109" y="162.698" width="56" height="2" fill="#0C0722" />
			<rect x="109" y="172.698" width="56" height="2" fill="#0C0722" />
			<rect
				x="135.252"
				y="20.6985"
				width="35.7486"
				height="35.7486"
				transform="rotate(15 135.252 20.6985)"
				fill="white"
			/>
			<rect
				x="143.023"
				y="26.9155"
				width="35.7486"
				height="35.7486"
				transform="rotate(15 143.023 26.9155)"
				fill="#FB1E9B"
			/>
			<rect
				x="139.068"
				y="21.9232"
				width="33.7486"
				height="33.7486"
				transform="rotate(15 139.068 21.9232)"
				stroke="#0C0722"
				strokeWidth="2"
			/>
		</svg>
	)
};
